export default __webpack_public_path__ + "static/frial-bg-8456a173c38db53f1e59dd5af123af37.png";